(function () {
  var documentClickBound = false;

  function bindOnce(element, key) {
    var attr = 'data-kvsche-' + key + '-bound';
    if (!element || element.getAttribute(attr) === 'true') return false;
    element.setAttribute(attr, 'true');
    return true;
  }

  function closeSelect(select) {
    var button = select.querySelector('[data-kvsche-contact-select-button]');
    select.classList.remove('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  }

  function openSelect(select, focusOption) {
    var button = select.querySelector('[data-kvsche-contact-select-button]');
    var selected = select.querySelector('[data-kvsche-contact-select-option].is-selected');
    var first = select.querySelector('[data-kvsche-contact-select-option]');
    select.classList.add('is-open');
    if (button) {
      button.setAttribute('aria-expanded', 'true');
    }
    if (focusOption) {
      (selected || first || button).focus();
    }
  }

  function setActiveOption(select, option) {
    select.querySelectorAll('[data-kvsche-contact-select-option]').forEach(function (item) {
      item.classList.toggle('is-active', item === option);
    });
  }

  function chooseOption(select, option) {
    var valueInput = select.parentElement.querySelector('[data-kvsche-contact-select-value]');
    var text = select.querySelector('[data-kvsche-contact-select-text]');
    var value = option.getAttribute('data-value') || option.textContent.trim();

    select.querySelectorAll('[data-kvsche-contact-select-option]').forEach(function (item) {
      var isSelected = item === option;
      item.classList.toggle('is-selected', isSelected);
      item.classList.remove('is-active');
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    if (valueInput) {
      valueInput.value = value;
    }
    if (text) {
      text.textContent = value;
    }
  }

  function moveFocus(select, direction) {
    var options = Array.prototype.slice.call(select.querySelectorAll('[data-kvsche-contact-select-option]'));
    var current = document.activeElement;
    var currentIndex = options.indexOf(current);
    var selectedIndex = options.findIndex(function (option) {
      return option.classList.contains('is-selected');
    });
    var startIndex = currentIndex >= 0 ? currentIndex : selectedIndex;
    var nextIndex = startIndex + direction;

    if (nextIndex < 0) {
      nextIndex = options.length - 1;
    }
    if (nextIndex >= options.length) {
      nextIndex = 0;
    }

    if (options[nextIndex]) {
      setActiveOption(select, options[nextIndex]);
      options[nextIndex].focus();
    }
  }

  function initKvscheContact() {
    var roots = document.querySelectorAll('[data-kvsche-contact]');

    roots.forEach(function (root) {
      root.querySelectorAll('[data-kvsche-contact-select]').forEach(function (select) {
        var button = select.querySelector('[data-kvsche-contact-select-button]');
        var options = select.querySelectorAll('[data-kvsche-contact-select-option]');

        if (!button || !options.length) {
          return;
        }

        if (bindOnce(button, 'contact-select-button')) {
          button.addEventListener('click', function () {
            if (select.classList.contains('is-open')) {
              closeSelect(select);
            } else {
              openSelect(select, false);
            }
          });

          button.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault();
              openSelect(select, true);
              if (event.key === 'ArrowUp') {
                moveFocus(select, -1);
              }
            }
            if (event.key === 'Escape') {
              closeSelect(select);
            }
          });
        }

        options.forEach(function (option) {
          if (!bindOnce(option, 'contact-select-option')) return;

          option.addEventListener('mouseenter', function () {
            setActiveOption(select, option);
          });

          option.addEventListener('click', function () {
            chooseOption(select, option);
            closeSelect(select);
            button.focus();
          });

          option.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown') {
              event.preventDefault();
              moveFocus(select, 1);
            }
            if (event.key === 'ArrowUp') {
              event.preventDefault();
              moveFocus(select, -1);
            }
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              chooseOption(select, option);
              closeSelect(select);
              button.focus();
            }
            if (event.key === 'Escape') {
              closeSelect(select);
              button.focus();
            }
          });
        });
      });
    });

    if (!documentClickBound) {
      document.addEventListener('click', function (event) {
        document.querySelectorAll('[data-kvsche-contact-select].is-open').forEach(function (select) {
          if (!select.contains(event.target)) {
            closeSelect(select);
          }
        });
      });
      documentClickBound = true;
    }
  }

  function isKvscheContactSection(root) {
    if (!root || !root.querySelector) return false;

    return Boolean(
      (root.matches && root.matches('[data-kvsche-contact]')) ||
      root.querySelector('[data-kvsche-contact]')
    );
  }

  initKvscheContact();

  document.addEventListener('shopify:section:load', function (event) {
    if (!isKvscheContactSection(event.target)) return;
    initKvscheContact();
  });
})();
